/**
 * ContactInformationModel
 */
class ContactInformationModel {
    /**
     * @param {string} firstName
     * @param {string} lastName
     * @param {string} email
     * @param {string} phonenumber
     */
    constructor(firstName='', lastName='',
        email='', phonenumber='') {
        this.first_name = firstName
        this.last_name = lastName
        this.email = email
        this.phonenumber = phonenumber
    }

    /**
     * @param {json} json
     * @return {ContactInformationModel}
     */
    static from(json) {
        const contact =
            Object.assign(new ContactInformationModel(), json)
        return contact
    }

    /**
     * Will remove all the info not needed for
     * an asante contact info.
     * @param {json} json
     * @return {ContactInformationModel}
     */
    static fromAsante(json) {
        const contact =
            Object.assign(new ContactInformationModel(), json)
        delete contact['phonenumber']
        return contact
    }

    /**
     * Fill in information need like a copy
     * @param {json} contacts
     * @param {boolean} overrideFill
     */
    fillInInformation(contacts, overrideFill) {
        const params = [
            'first_name', 'last_name',
            'email', 'phonenumber',
        ]
        for (let i = 0; i < params.length; i++) {
            if (this[params[i]].length === 0 || i === 0 || overrideFill) {
                this[params[i]] = contacts[params[i]]
            }
        }
    }
}

module.exports = {
    ContactInformationModel,
}

